import React, { useContext, useRef } from "react";

import { Link } from "react-router-dom";

import DatabaseContext from "data/contextDatabase";
import IconDropDown from "ui/Dropdown/iconDropDown";
import IconDelete from "ui/Dropdown/iconDelete";
import IconShare from "ui/Dropdown/iconShare";

const UIDialog = (props) => {
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);

  const destroyDialog = () => {
    databaseState.dbMaster
      .allDocs({
        include_docs: true,
        startkey: "54dialog4",
        endkey: "54dialog5",
      })
      .then((allDocs) => {
        let to_delete = allDocs.rows.filter(
          (item) => item.doc.mdialog === props.dialog.mdialog
        );
        to_delete.map((r) => {
          let m = {
            type: "DELETE_RECORD_ID",
            values: {
              db: databaseState.dbMaster,
              doc: r.doc,
            },
          };
          console.log("destroyDialog: ", m);
          databaseState.dbMaster && databaseDispatch(m);
          return "";
        });
      });
    // Should we also delete all messages?
  };

  let shareLink = () => {
    let link =
      "https://world.reaches.me/dialog/" +
      props.dialog.mpersona +
      "/" +
      props.dialog.persona;
    props.share(props.dialog.persona, link);

    // var share_modal = document.getElementById("share_modal");
    // document.getElementById("share_modal_link_title").innerHTML =
    //   props.dialog.persona;
    // document.getElementById("share_modal_link").innerHTML = link;

    // share_modal.style.display = "block";

    // document.getElementById("share_modal").style.display = "block";
  };

  const menuItems = [
    {
      icon: <IconShare />,
      callback: shareLink,
    },
    {
      icon: <IconDelete />,
      callback: destroyDialog,
    },
  ];

  console.log("dialog: ", props.dialog);
  let content = (
    <div>
      <div>
        <div className="UI-topic">
          <Link
            key={props.dialog.mdialog}
            className="UI-topic-link"
            style={{ color: "#f09f70", textDecoration: "none" }}
            to={{
              pathname: "/UIMessageList",
              state: {
                dialog: props.dialog,
              },
            }}
          >
            <li className="UI-topic-link">
              <div className="UI-topic-inner">
                <div className="UI-topic-tdn hide-scrollbar">
                  {props.dialog.topic_display_name || props.dialog.dialog}
                </div>
                <div className="UI-topic-persona hide-scrollbar">
                  {props.dialog.persona}
                </div>
                <div className="UI-topic-count">
                  {databaseState.liveCount[props.dialog.mdialog]}
                </div>
              </div>
            </li>
          </Link>
          <IconDropDown className=".UI-icondropdown" menuItems={menuItems} />
        </div>
      </div>
    </div>
  );

  return content;
};

export default React.memo(UIDialog, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
